import React, { useState } from "react";
import { Link } from "react-router-dom";
import { portfolio } from "../../constants/portfolio";

const PortfolioSection = () => {
  const [activeCategory, setActiveCategory] = useState("All");
  const [selectedImages, setSelectedImages] = useState(null); // array of images for the modal
  const [selectedIndex, setSelectedIndex] = useState(0);

  const categories = [
    "All",
    "Website",
    "System",
    "Blog",
    "UX UI Design",
    "Artwork",
    "Logo Design",
    "Video Editing",
  ];

  const filteredPortfolio =
    activeCategory === "All"
      ? portfolio
      : portfolio.filter((item) => item.category === activeCategory);

  const openModal = (imgs, index = 0) => {
    setSelectedImages(imgs);
    setSelectedIndex(index);
  };

  const closeModal = () => {
    setSelectedImages(null);
    setSelectedIndex(0);
  };

  const showPrev = (e) => {
    e.stopPropagation();
    setSelectedIndex((prev) =>
      prev === 0 ? selectedImages.length - 1 : prev - 1,
    );
  };

  const showNext = (e) => {
    e.stopPropagation();
    setSelectedIndex((prev) =>
      prev === selectedImages.length - 1 ? 0 : prev + 1,
    );
  };

  return (
    <div className="container-fluid h-100vh">
      {/* Modal Overlay */}
      {selectedImages && (
        <div
          onClick={closeModal}
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.7)",
            backdropFilter: "blur(6px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            cursor: "zoom-out",
          }}
        >
          <img
            src={selectedImages[selectedIndex]}
            alt="Preview"
            onClick={(e) => e.stopPropagation()}
            style={{
              maxWidth: "90vw",
              maxHeight: "90vh",
              borderRadius: "12px",
              boxShadow: "0 0 40px rgba(0,0,0,0.6)",
              objectFit: "contain",
            }}
          />

          <button
            onClick={closeModal}
            style={{
              position: "absolute",
              top: "20px",
              right: "24px",
              background: "transparent",
              border: "none",
              color: "#fff",
              fontSize: "2rem",
              cursor: "pointer",
              lineHeight: 1,
            }}
          >
            &times;
          </button>

          {/* Prev/Next controls, only show if more than one image */}
          {selectedImages.length > 1 && (
            <>
              <button
                onClick={showPrev}
                style={{
                  position: "absolute",
                  left: "24px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  background: "rgba(255,255,255,0.15)",
                  border: "none",
                  color: "#fff",
                  fontSize: "2rem",
                  cursor: "pointer",
                  lineHeight: 1,
                  borderRadius: "50%",
                  width: "48px",
                  height: "48px",
                }}
              >
                &#8249;
              </button>
              <button
                onClick={showNext}
                style={{
                  position: "absolute",
                  right: "24px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  background: "rgba(255,255,255,0.15)",
                  border: "none",
                  color: "#fff",
                  fontSize: "2rem",
                  cursor: "pointer",
                  lineHeight: 1,
                  borderRadius: "50%",
                  width: "48px",
                  height: "48px",
                }}
              >
                &#8250;
              </button>

              {/* Dots indicator */}
              <div
                onClick={(e) => e.stopPropagation()}
                style={{
                  position: "absolute",
                  bottom: "24px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  display: "flex",
                  gap: "8px",
                }}
              >
                {selectedImages.map((_, i) => (
                  <span
                    key={i}
                    onClick={() => setSelectedIndex(i)}
                    style={{
                      width: "10px",
                      height: "10px",
                      borderRadius: "50%",
                      backgroundColor:
                        i === selectedIndex
                          ? "#5bc0de"
                          : "rgba(255,255,255,0.5)",
                      cursor: "pointer",
                      transition: "background-color 0.2s ease",
                    }}
                  ></span>
                ))}
              </div>
            </>
          )}
        </div>
      )}

      <div className="container text-center margin-top-portfolio">
        <div className="d-flex justify-content-center align-items-center mb-2">
          <span
            style={{
              height: "2px",
              width: "30px",
              backgroundColor: "#5bc0de",
              marginRight: "10px",
            }}
          ></span>
          <span className="text-uppercase fw-bold">MY PORTFOLIO</span>
        </div>

        <h2 className="fw-bold mb-4 complete">My Excellent Portfolio</h2>

        <div className="d-flex flex-wrap justify-content-center gap-2 mb-5">
          {categories.map((cat, index) => (
            <button
              key={index}
              onClick={() => setActiveCategory(cat)}
              className="btn fw-bold px-4 py-2"
              style={{
                backgroundColor:
                  activeCategory === cat ? "transparent" : "#5bc0de",
                color: activeCategory === cat ? "#5bc0de" : "",
                border: "2px solid #5bc0de",
                borderRadius: "5px",
                transition: "all 0.3s ease",
              }}
            >
              {cat}
            </button>
          ))}
        </div>

        <div
          className="row g-4 mb-4 align-items-center"
          style={{ minHeight: "400px" }}
        >
          {filteredPortfolio.length > 0 ? (
            filteredPortfolio.map((items, index) => {
              // Normalize img to always be an array, so items can have 1 or many images
              const images = Array.isArray(items.img) ? items.img : [items.img];

              return (
                <div
                  key={index}
                  className="col-12 col-sm-12 col-md-6 col-lg-4"
                  data-aos="zoom-in-up"
                >
                  <div className="p-3 h-100 border rounded-4 shadow-sm d-flex flex-column justify-content-between">
                    <div className="mb-3">
                      <h4 className="fw-bold text-info">{items.title}</h4>
                      <p className="text-secondary">{items.description}</p>
                    </div>

                    <div className="mb-3" style={{ position: "relative" }}>
                      <img
                        className="img-fluid rounded-3 hover-scale"
                        src={images[0]}
                        alt={items.title}
                        onClick={() => openModal(images, 0)}
                        style={{
                          maxHeight: "250px",
                          width: "100%",
                          objectFit: "contain",
                          cursor: "zoom-in",
                        }}
                      />

                      {/* Badge showing image count, only if more than one */}
                      {images.length > 1 && (
                        <span
                          onClick={() => openModal(images, 0)}
                          style={{
                            position: "absolute",
                            bottom: "8px",
                            right: "8px",
                            backgroundColor: "rgba(0,0,0,0.6)",
                            color: "#fff",
                            fontSize: "0.75rem",
                            fontWeight: 600,
                            padding: "2px 8px",
                            borderRadius: "12px",
                            cursor: "pointer",
                          }}
                        >
                          +{images.length - 1} more
                        </span>
                      )}
                    </div>

                    {items.link && (
                      <Link
                        to={items.link}
                        className="btn btn-outline-info fw-semibold"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Live Demo
                      </Link>
                    )}
                  </div>
                </div>
              );
            })
          ) : (
            <div className="col-12 text-center">
              <h5>No projects available in this category</h5>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PortfolioSection;
